export const CustomerTestimonials = () => {
  return (
    <div className="flex flex-col gap-2 md:gap-4 items-center py-10 md:py-20 bg-[#EAFCFF]">
      <h2 className="text-[40px] px-14 md:px-0 md:text-5xl font-bold text-center text-[#181818]">
        Trusted by over 50,000+ customers
      </h2>
      <p className="text-center px-8 font-medium text-[18px]">
        Don't take our word for it. Here's what other people are saying about
        us...
      </p>

      <script src="https://static.elfsight.com/platform/platform.js" async />
      <div
        className="elfsight-app-cc3aeaf3-1399-45c6-b641-0ccc70aa3d9c"
        data-elfsight-app-lazy
        data-theme="light"
      />
    </div>
  );
};
